<template>
  <div class="md-layout">
    <h2 class="mobile-page-title">Project Info</h2>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 link-to-gpr">
      <md-button class="md-sm md-primary" @click="viewJSA">
        {{ project.jsa !== null ? 'View JSA report' : 'Start/Continue JSA' }}
      </md-button>
      <template v-if="project.gpr_report.data !== null">
        <md-button class="md-sm md-primary" @click="viewGPRReport">View GPR Report</md-button>
      </template>
      <router-link v-if="project.gpr_report.data === null && gprAccess == true"
        :to="{ name: 'GPR Report', params: { id: project.project.id }}">
        <md-button class="md-sm md-primary">Start/Continue GPR Report</md-button>
      </router-link>
    </div>
    <h5 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles">Main Info</h5>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
      <div class="subheading">ATS Number</div>
      <div class="title">{{project.ats_data.ats_number}}</div>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item">
      <div class="subheading">Job Site</div>
      <div class="title">{{project.address.street_address}}</div>
      <div class="title" v-if="project.address">
        {{project.address.city}}, {{project.address.state}} {{project.address.zip}}
      </div>
      <div class="title no-item" v-else>
        No Address
      </div>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item"
      v-if="project.ats_company.name">
      <div class="subheading">Client Company</div>
      <div class="title">{{project.ats_company.name}}</div>
      <div class="facility title" v-if="project.facility && project.facility.name">({{ project.facility.name }})</div>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.site_contact)">
      <div class="subheading">Site Contact</div>
      <div class="title">{{project.site_contact.name}} <br /> {{project.site_contact.phone}} <br />
        {{project.site_contact.email}}</div>
    </div>
    <h5 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles">ATS Request Info</h5>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.requested_start_date)">
      <div class="subheading">Requested Start Date</div>
      <div class="title">{{project.ats_data.requested_start_date | formatDate}}</div>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.requested_start_time)">
      <div class="subheading">Requested Time Date</div>
      <div class="title">{{project.ats_data.requested_start_time}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.building_type)">
      <div class="subheading">Building Type</div>
      <div class="title">{{project.ats_data.building_type}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.type_to_be_scanned)">
      <div class="subheading">Type of Floor or Wall to be scanned</div>
      <div class="title">{{project.ats_data.type_to_be_scanned}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.gpr_scan_for_floor_sawing)">
      <div class="subheading">GPR Scan for Coring</div>
      <div class="title">{{project.ats_data.gpr_scan_for_coring}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.gpr_scan_for_floor_sawing)">
      <div class="subheading">GPR Scan for Floor Sawing</div>
      <div class="title">{{project.ats_data.gpr_scan_for_floor_sawing}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.gpr_scan_for_beams_or_columns)">
      <div class="subheading">GPR Scan for Beams or Columns</div>
      <div class="title">{{project.ats_data.gpr_scan_for_beams_or_columns}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.gpr_scan_for_vids_utilities_or_underground_detection)">
      <div class="subheading">GPR Scan for voids, site utilities, or underground detection</div>
      <div class="title">{{project.ats_data.gpr_scan_for_vids_utilities_or_underground_detection}}</div>
    </div>
    <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.additional_info)">
      <div class="subheading">Additional Job Info</div>
      <div class="title">{{project.ats_data.additional_info}}</div>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.purchase_order_number)">
      <div class="subheading">Purchase Order #</div>
      <div class="title">{{project.ats_data.purchase_order_number}}</div>
    </div>
    <div class="md-layout-item md-size-50 md-medium-size-100 md-small-size-100 info-item"
      v-if="check(project.ats_data.job_number)">
      <div class="subheading">Job #</div>
      <div class="title">{{project.ats_data.job_number}}</div>
    </div>
    <!-- <h5 class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 titles">Signature</h5>
    <ATSTerms v-bind:infotab="true"/>
    <div class="md-layout-item md-size-100 info-item">
      <div class="md-layout-item md-size-45 info-item">
        <img v-bind:src="project.ats_data.customer_signature" alt="" class="displayed-signature">
        <div class="title">
          {{project.ats_data.signed_user_name}}
        </div>
        <div class="title bold">
          {{project.ats_data.signed_company_name}}
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>

// import ATSTerms from "@/pages/Dashboard/ProjectPages/Components/ATSTerms.vue";
import moment from 'moment';

  export default {
    components: {
      // ATSTerms
    },
    props: {
      project: {
        type: Object,
        default: function() {
          return {
            project: {
              project: {
                address: {}
              },
              ats_data: {},
              address: {},
              users: [],
              ats_company: {},
              site_contact: {},
              locations: [],
              gpr_report: {}
            },
          }
        }
      },
    },
    computed: {
      gprAccess(){
        return this.$store.state.user.gpr_access;
      }
    },
    // mounted(){
    //   this.gprAccess = this.$store.state.user.gpr_access;
    //   console.log(this.project)
    //   console.log(this.$store.state.user)
    //   console.log(this.gprAccess)
    // },
    methods: {
      check(variable) {
        if (variable == {} || variable == '' || variable == null){
          return false
        } else {
          return true
        }
      },
      viewGPRReport(){
        this.$router.push(`/gprreportview/${this.project.project.id}`)
      },
      viewJSA() {
        this.$router.push(`/jsaformview/${this.project.project.id}`)
      },
    },
    data() {
      return {
        ifAdmin: this.$store.getters.isAdmin
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('MM/DD/YYYY')
        }
      }
    }
  }
</script>
<style>
  .link-to-gpr {
    text-align: right;
  }
  .titles {
    /* margin: 0; */
    padding: 0;
    margin: 10px 0;
    text-transform: uppercase;
    border-bottom: 1px solid black;
  }
  .mobile-page-title {
    display: none;
  }
  @media (max-width: 900px){
    .mobile-page-title {
      display: inherit;
      font-size: 15px;
      text-align: center;
      font-weight: bold;
      text-transform: uppercase;
      
    }
  }
</style>



<!-- <div class="title no-item" v-else>No Job Number</div> -->
